import React from 'react';
import pt from 'prop-types';

import Modal from 'components/modal';
import { renderMarkdown } from 'utils/string';

/**
 * The full description is markdown and runs to hundreds of words, so the
 * version details table shows only a preview. This renders the whole thing.
 */
export default class AppFullDescription extends React.PureComponent {
  static propTypes = {
    description: pt.string,
    version: pt.string,
  };

  render() {
    const { description, version } = this.props;

    return (
      <Modal
        title="Full description"
        subtitle={version ? `Version ${version}` : undefined}
        width={720}
        cancelText="Close"
      >
        <div className="app-full-description">
          {renderMarkdown(description)}
        </div>
      </Modal>
    );
  }
}
